import { Routes } from "@angular/router";

export const financialReportsRoutes: Routes = [
  { path: "", redirectTo: "statistical", pathMatch: "full" },
  {
    path: "financial",
    loadComponent: () => import("./pages/financial-report/financial-report.component").then((m) => m.FinancialReportComponent),
  },
  {
    path: "statistical",
    loadComponent: () => import("./pages/financial-report/financial-report.component").then((m) => m.FinancialReportComponent),
  },
  {
    path: "statistics-visitor",
    loadComponent: () =>
      import("./pages/statistics-visitor-report/statistics-visitor-report.component").then((m) => m.StatisticsVisitorReportComponent),
  },
  {
    path: "products",
    loadComponent: () => import("./pages/products-report/products-report.component").then((m) => m.ProductsReportComponent),
  },
  {
    path: "evaluation-form",
    loadComponent: () => import("./pages/evaluation-form/evaluation-form.component").then((m) => m.EvaluationFormComponent),
  },
  {
    path: "intrests-cards",
    loadComponent: () =>
      import("./pages/intrests-cards-report/intrests-cards-report.component").then((m) => m.IntrestsCardsReportComponent),
  },
  {
    path: "standard",
    loadComponent: () =>
      import("./pages/standard-financial-report/standard-financial-report.component").then((m) => m.StandardFinancialReportComponent),
  },
  {
    path: "peak-hours",
    loadComponent: () => import("./pages/peak-hours-report/peak-hours-report.component").then((m) => m.PeakHoursReportComponent),
  },
];
